import React, { useEffect, useState } from "react";
import AdminReply from "./AdminReply";

const ProjectCommunication = ({ projectDetails = {} }) => {
  const [communications, setCommunications] = useState([]);

  useEffect(() => {
    setCommunications(projectDetails?.actions_communication ?? []);
  }, [projectDetails]);

  return (
    <div className="mt-4">
      <h3 className="text-3xl font-semibold">Communication</h3>
      {communications.map((message, index) => (
        <div key={`${index}_reply`}>
          <AdminReply message={message} setChat={setCommunications} />
        </div>
      ))}
    </div>
  );
};

export default ProjectCommunication;
